import baseMixins from '../mixins/baseMixins' // 基础地图载入配置[必须]
import toolMixins from '../mixins/toolMixins' // 工具函数[必须]
import apiMixins from '../mixins/apiMixins' // 可直接调用的对外方法[必须][可覆盖]
import './JsxGisMap.css'
export default {
  render () {
    return (
      <div class={[this.currentMeasureType, 'j-gis-map-layout']}>
        <div class="j-gis-map" id={this.mapRandomId}/>
        { this.showCoordinate ? <j-gis-coord point={this.coordinateTarget}/> : '' }
        { this.$slots.control }
        { this.$slots.default }
      </div>
    )
  },
  mixins: [baseMixins, toolMixins, apiMixins]
}
